import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkPanelMenuBarComponent } from './work-panel-menu-bar/work-panel-menu-bar.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WorkPanelPopOutComponent } from './work-panel-pop-out/work-panel-pop-out.component';
import { WorkPanelStandaloneComponent } from './work-panel-standalone/work-panel-standalone.component';
import { PopupModule } from '@soti/popup';
import { WorkPanelRC2Component } from './work-panel-rc2.component';
import { RemoteControlModule } from 'app/modules/remote-control/remote-control.module';
import { SnapshotModule } from '../snapshot/snapshot.module';
import { SharedComponentsModule } from 'app/shared/shared-components.module';
import { PipesModule } from '@nx-fe/pipes';
import { SharedDialogsModule } from '@nx-fe/shared-dialogs';
import { TicketCreationModule } from '../../ticket-creation.module';
import { FilePreviewComponent } from 'xsmodules/ticket/components/work-panel/file-preview/file-preview.component';
import { QuillModule } from 'ngx-quill';
import { SelectModule } from '@soti/select';
import { AttachmentMediaComponent } from 'xsmodules/ticket/components/work-panel/attachment-media/attachment-media.component';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from '@soti/tooltip';
import { SvgIconsModule } from '@nx-fe/icons';
import { ChatToggleButtonComponent } from '@nx-fe/sabha';

@NgModule({
  imports: [
    CommonModule,
    SharedDialogsModule,
    SnapshotModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    RemoteControlModule,
    MatCheckboxModule,
    SharedComponentsModule,
    PopupModule,
    PipesModule,
    TicketCreationModule,
    QuillModule,
    SelectModule,
    FormsModule,
    TooltipModule,
    SvgIconsModule,
    ChatToggleButtonComponent
  ],
  declarations: [
    WorkPanelMenuBarComponent,
    WorkPanelPopOutComponent,
    WorkPanelStandaloneComponent,
    WorkPanelRC2Component,
    WorkPanelPopOutComponent,
    FilePreviewComponent,
    AttachmentMediaComponent,
  ],
  exports: [AttachmentMediaComponent, WorkPanelRC2Component, WorkPanelMenuBarComponent, WorkPanelStandaloneComponent],
})
export class WorkPanelModule {}
